import { useEffect, useState } from 'react';

/**
 * ejemplo de headers:
 * [
 *  {
 *    name:'nombre',
 *    content:'contenido del header'
 *  }
 * ]
 *
 */

//TODO: Pasar url a un archivo .env
const url_base = 'http://api-eventos.creson.edu.mx/api/';

//TODO: Revisar si el hook se puede usar tal como esta para registrar nueva información a la BD o si requiere modificación

export const useFetch = (endpoint = '', method = 'GET', body = {}, headers) => {
  const [state, setState] = useState({
    data: null,
    isLoading: true,
    hasError: null,
  });
  const getFetch = async () => {
    setState({
      ...state,
      isLoading: true,
    });

    const requestOptions = {
      method,
      headers: { 'Content-type': 'application/json', ...headers },
      redirect: 'follow',
    };

    if (method != 'GET') {
      requestOptions = { ...requestOptions, body };
    }

    const resp = await fetch(url_base + endpoint, requestOptions);
    const data = await resp.json();

    if (resp.status >= 200 && resp.status < 299) {
      setState({
        data,
        isLoading: false,
        hasError: false,
      });
    } else {
      setState({
        data,
        isLoading: false,
        hasError: true,
      });
    }
  };

  useEffect(() => {
    getFetch();
  }, [endpoint]);

  return {
    data: state.data,
    isLoading: state.isLoading,
    hasError: state.hasError,
  };
};
